import React from 'react';

import styled from 'styled-components';

// theme
import aampeTheme from '../../constants/aampeTheme';

// models
import { ElementKind } from '../../models/editor.model';

import FormulaSidebarCMSFilters from './FormulaSidebarCMSFilters';
// components
import FormulaSidebarDataset from './FormulaSidebarDataset';
import FormulaSidebarVariant from './FormulaSidebarVariant';

interface SectionProps {
    isLiteMode: boolean;
    removeSpacing?: boolean;
}
interface FormulaSidebarProps {
    selectedComponent: Record<string, any> | null;
    data: any;
    isLiteMode?: boolean;
    formulaId?: number;
    removeSpacing?: boolean;
}

const FormulaSidebar: React.FC<React.PropsWithChildren<FormulaSidebarProps>> =
    ({
        selectedComponent,
        data,
        isLiteMode = false,
        formulaId,
        removeSpacing,
    }) => {
        return (
            <Section isLiteMode={isLiteMode} removeSpacing={removeSpacing}>
                {selectedComponent?.kind === ElementKind.variant ? (
                    <FormulaSidebarVariant
                        data={data}
                        formulaId={Number(formulaId)}
                        selectedElement={selectedComponent}
                    />
                ) : selectedComponent?.kind === ElementKind.dataset ? (
                    <FormulaSidebarDataset
                        selectedComponent={selectedComponent}
                    />
                ) : selectedComponent?.kind === ElementKind.cms_placeholder ? (
                    <FormulaSidebarCMSFilters
                        selectedComponent={selectedComponent}
                    />
                ) : null}
            </Section>
        );
    };

const Section = styled.div.withConfig({
    shouldForwardProp: (prop) =>
        !['isLiteMode', 'removeSpacing'].includes(prop),
})<SectionProps>(({ isLiteMode, removeSpacing }) => ({
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexFlow: 'column nowrap',
    backgroundColor: aampeTheme.colors.white,
    borderRadius: aampeTheme.borderRadius.default,
    flexGrow: 1,
    maxWidth: '600px',
    maxHeight: isLiteMode ? '400px' : '700px',
    overflowY: 'scroll', // corrected typo from 'overflowy'
    paddingTop: removeSpacing ? 0 : aampeTheme.spacing(1),
}));

export default FormulaSidebar;
